<template>
  <div class="application" id="application">
    <my-header />

    <!-- 标题应用和定制 -->
    <div class="pre">
      <div class="allTitle">
        <span>应用</span>
      </div>
    </div>

    <!-- 文字1 -->
    <div class="pre">
      <div class="word1">
        <div>
          瀚佰锐五金合作的酒店和商务部直接与设计和开发团队合作，为每个项目确定最佳解决方案。
        </div>
        <div>
          从现有集合的微小修改到一个完全原始的构想，我们可以创建任何可以想象得到的东西，所有东西都严格按照规范进行定制。
        </div>
        <div>
          我们在处理全球大型项目方面拥有丰富的经验，并欢迎有机会与您合作，以确保您的工作取得成功.
        </div>
      </div>
    </div>

    <!-- 图片1 -->
    <div class="appImg">
      <img src="../assets/07.jpg" />
    </div>

    <div class="pre">
      <div class="wordTitle">
        <span>酒店产品</span>
      </div>
    </div>

    <!-- 文字2 -->
    <div class="pre">
      <div class="word2">
        瀚佰锐五金完整产品提供严格的生产制造，以满足商业应用的要求。
        我们注重质量，结合产品保证，使我们的五金成为高端装饰五金的首选，让对细节至关重要的项目的理想选择。
        尽管我们的标准产品已经满足项目的需求，但我们也以创造独特的产品而著称，例如智能铜锁，可以保证高质量的同时让设计细化到最小的细节。
      </div>
    </div>

    <test :dataList="dataList" />

    <test-phone :dataList="dataList" class="test-phone" />

    <div class="card">
      <b-container class="cardBar">
        <b-row no-gutters>
          <b-col class="col" cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
            <img src="../assets/08.jpg" />
          </b-col>
          <b-col
            class="col cardWordOne"
            cols="12"
            xs="12"
            sm="12"
            md="6"
            lg="6"
            xl="6"
          >
            <div class="cardTitle">兼容性</div>
            <div class="cardWord1">
              -所有瀚佰锐的铜锁和智能锁均在中国制造，并通过IS09901质量管理体系认证，盐雾测试、附着力测试和硬度测试等。
            </div>
            <div class="cardWord1">
              -所有的铜锁都可以提供各种后置选项，可以智能化或者机械化并与特殊功能配合使用，例如储藏室，办公室和教室。
            </div>
            <div class="cardWord1">
              -我们目前提供的产品内在的功能包括与RFID技术结合用于酒店房间入户门的功能，也是用于出口五金的外部装饰以及用于公共厕所的隐私指示器锁等。
            </div>
          </b-col>
          <b-col
            class="col cardWordTwo"
            cols="12"
            xs="12"
            sm="12"
            md="6"
            lg="6"
            xl="6"
          >
            <div class="cardTitle1">DIY定制</div>
            <div class="cardWord2">
              近三十年来，瀚佰锐五金一直在寻求客户的灵感。
              一直不断地努力学习钻研现代铜加工工艺，保证生产流程的顺畅和对产品品质的全面监控，
              与此同时，也一直追求对装饰五金款式的自我创新，大力开展产品开发，
            </div>
            <div class="cardWord2">
              “永不拒绝”的理念是我们公司来赖以建立的基础。
              如今，我们继续秉承这一传统，与客户合作，以真正的工匠魅力创造出独一无二的设计。
            </div>
            <div class="alink">
              <a
                href="javascript:void(0)"
                @click="
                  toView(
                    '/hbrApplicationDesign?go=hbrApplicationDesign',
                    'hbrApplicationDesign'
                  )
                "
                >查看定制产品图库</a
              >
            </div>
          </b-col>
          <b-col class="col" cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
            <img src="../assets/09.jpg" />
          </b-col>
        </b-row>
      </b-container>
    </div>

    <!--这个怎么做图片 -->
    <div class="pre">
      <img src="../assets/10.jpg" style="padding-top: 80px;width: 100%;" />
    </div>

    <div class="pre">
      <div class="doit">
        <div class="doTitle">这个是怎么做的</div>
        <div class="doWord">
          耗时的制造过程可实现完全定制，从开始到结束，每件作品均需触摸不少于30只手。
        </div>
      </div>
    </div>

    <div class="pre">
      <div class="footimg clear">
        <div class="itemImg left">
          <img src="../assets/11.jpg" />
          <span>模具</span>
          <p style="width: 70%;">全面卓越的模具开发与生产能力</p>
        </div>
        <div class="itemImg left">
          <img src="../assets/12.jpg" />
          <span>锻压</span>
          <p>久经钻研的锻压红冲工艺</p>
        </div>
        <div class="itemImg left">
          <img src="../assets/13.jpg" />
          <span>精加工</span>
          <p>精密且配合到位的CNC精加工</p>
        </div>
        <div class="itemImg left">
          <img src="../assets/14.jpg" />
          <span>表面处理</span>
          <p>完美无瑕的抛光和表面处理</p>
        </div>
        <div class="itemImg left">
          <img src="../assets/15.jpg" />
          <span>成品</span>
          <p>艺术品般的高品质成品</p>
        </div>
      </div>
    </div>

    <!-- 图片 -->
    <div class="appImg">
      <img src="../assets/yy1.jpg" />
    </div>

    <div class="hotelProject pre">
      <div class="wordTitle">
        <span>酒店项目</span>
      </div>
      <div class="word2">
        从豪华水疗中心到五星级度假胜地再到精品酒店，瀚佰锐五金始终与全球众多设计和项目团队合作，务求把产品做到极致。
      </div>
      <div class="hotelImg">
        <div class="projectImg clear">
          <div class="left"><img src="../assets/yy2.jpg" /></div>
          <div class="left"><img src="../assets/yy3.jpg" /></div>
          <div class="left"><img src="../assets/yy4.jpg" /></div>
        </div>
      </div>
    </div>

    <my-footer />
  </div>
</template>

<script>
import myHeader from "@/views/myHeader.vue";
import myFooter from "@/views/myFooter.vue";
import test from "@/views/test.vue";
import testPhone from "@/views/testPhone.vue";

export default {
  components: {
    myHeader,
    myFooter,
    test,
    testPhone
  },
  data() {
    return {
      dataList: []
    };
  },
  methods: {
    toView(path, goId) {
      if (this.$route.fullPath != path) {
        this.$router.push(path);
      } else {
        document.querySelector("#" + goId).scrollIntoView(true);
      }
    }
  },

  mounted() {
    // if (this.$route.query.go) {
    // 	document.querySelector("#" + this.$route.query.go).scrollIntoView(true)
    // }

    let that = this;
    that.$axios
      .get(
        that.$global.baseURL + "/web/productList/getProductDataByType.form",
        {
          params: {
            type: "3"
          }
        }
      )
      .then(res => {
        if (res.data.jsonArray == "error") {
          uni.showModal({
            title: res.data.errorInfo,
            showCancel: false
          });
        } else {
          that.dataList = res.data.dataList;
        }
      });
  }
};
</script>

<style>
/*最外层 */
.pre {
  width: 100%;
}

/* 第一行标题 */
.application .pre .allTitle {
  width: 90%;
  text-align: center;
  margin: 0 auto;
  color: #8d8c8c;
  font-size: 53px;
  padding: 40px 0;
  padding-left: 20px;
  border-bottom: 1px solid #c4c4c4;
  letter-spacing: 20px;
  font-weight: lighter;
}

.word1 {
  width: 90%;
  margin: 0 auto;
  text-align: center;
  letter-spacing: 1px;
  /* 
		margin:20px 0; */
  margin-top: 25px;
  margin-bottom: 25px;
}

.word1 div {
  font-size: 14px;
  color: #8d8c8c;
  padding-top: 20px;
}

.application .appImg img {
  width: 100%;
  margin: 30px 0;
}

.application .pre .wordTitle {
  width: 90%;
  text-align: center;
  margin: 0 auto;
  color: #8d8c8c;
  font-size: 45px;
  padding-top: 45px;
  letter-spacing: 10px;
  font-weight: lighter;
}

.word2 {
  width: 88%;
  margin: 0 auto;
  text-align: center;
  margin-top: 20px;
  font-size: 14px;
  line-height: 30px;
  letter-spacing: 1px;
  color: #8d8c8c;
  margin-bottom: 45px;
}

.card {
  width: 100%;
  border: 0;
  margin-top: 80px;
}

.card .cardBar {
  width: 80%;
}

.card img {
  width: 100%;
}

.card .cardWordOne {
  text-align: left;
  padding-left: 50px;
  color: #595757;
}

.card .cardWordTwo {
  text-align: left;
  color: #595757;
}

.card .cardWordOne .cardTitle {
  font-size: 45px;
  font-weight: lighter;
  letter-spacing: 10px;
}

.card .cardWordTwo .cardTitle1 {
  font-size: 45px;
  font-weight: lighter;
  letter-spacing: 10px;
  padding-top: 60px;
}

.card .cardWordOne .cardWord1 {
  padding-top: 30px;
  font-size: 15px;
  line-height: 28px;
  letter-spacing: 1px;
}

.card .cardWordTwo .cardWord2 {
  width: 80%;
  font-size: 15px;
  letter-spacing: 1px;
  line-height: 28px;
  padding-top: 40px;
}

.card .cardWordTwo .alink {
  margin-top: 60px;
  margin-bottom: 20px;
  letter-spacing: 1px;
}

.card .cardWordTwo a:link {
  text-decoration: none;
  color: #ccb356;
}

.card .cardWordTwo a:visited {
  color: #ccb356;
}

.doit {
  /* width: 80%; */
  max-width: 1030px;
  margin: 0 auto;
  margin-top: 50px;
  padding-left: 10px;
  color: #595757;
}

.doit .doTitle {
  font-size: 40px;
  font-weight: lighter;
  letter-spacing: 6px;
  padding-bottom: 15px;
}

.doit .doWord {
  font-size: 15px;
  letter-spacing: 1px;
  padding-bottom: 25px;
}

.footimg {
  /* width: 80%; */
  max-width: 1030px;
  margin: 0 auto;
  margin-top: 30px;
  padding-bottom: 30px;
  padding-left: 1%;
}

.footimg .itemImg {
  width: 20%;
}

.footimg .itemImg img {
  width: 95%;
  padding-bottom: 15px;
}

.footimg .itemImg span {
  font-size: 18px;
  font-weight: bold;
}

.footimg .itemImg p {
  font-size: 12px;
  margin-top: 10px;
  letter-spacing: 1px;
}

.col-change {
  padding-right: 0px !important;
  padding-left: 5px !important;
}

.hotelProject {
  margin-bottom: 75px;
}

.hotelImg {
  width: 100%;
  background-color: #efefef;
  margin: 0 auto;
  margin-top: 50px;
}

.projectImg {
  width: 90%;
  height: 100%;
  padding-bottom: 40px;
  margin: 0 auto;
  text-align: center;
}

.projectImg .left {
  width: 33%;
}

.projectImg img {
  /* width: 75%; */

  height: 350px;
  margin: 0 auto;
  margin-top: 50px;
  /* margin-left: 30px; */
  display: block;
  text-align: center;
}

.test {
  display: block;
}

.test-phone {
  display: none;
}

@media screen and (max-width: 576px) {
  .card .cardWordOne {
    padding-left: 0px;
  }

  .card .cardWordOne .cardTitle {
    font-size: 45px;
    font-weight: lighter;
    letter-spacing: 10px;
    margin-top: 15px;
  }

  .card .cardWordOne .cardWord1 {
    padding-top: 15px;
    font-size: 15px;
    line-height: 28px;
    letter-spacing: 1px;
  }

  .card .cardWordTwo {
    text-align: left;
    color: #595757;
  }

  .card .cardWordTwo .cardTitle1 {
    font-size: 45px;
    font-weight: lighter;
    letter-spacing: 10px;
    padding-top: 60px;
  }

  .card .cardWordTwo .cardWord2 {
    width: 100%;
    font-size: 15px;
    letter-spacing: 1px;
    line-height: 28px;
    padding-top: 20px;
  }

  .card .cardWordTwo .alink {
    margin-top: 30px;
    margin-bottom: 30px;
  }

  .projectImg .left {
    width: 100%;
    margin: 0 auto;
  }

  .projectImg img {
    width: 85%;
    margin: 0 auto;
    margin-top: 50px;
    /* margin: 75px 0 0; */
    /* margin-left: 56px; */
    /* 	margin-left: 6%; */
  }

  .test {
    display: none;
  }

  .test-phone {
    display: block;
  }
}
</style>
